{
    "Addusertitle": "Ajouter un compte d'utilisateur d'application",
    "Modifyusertitle": "Modifier le compte utilisateur de l'application",
    "PermissionsTitle": "Permissions",
    "ExtensionTitle": "Extension\/Endpoint",
    "ReportingTitle": "Rapportage",
    "AdministratorTitle": "Administrateur",
    "RoleTitle": "Rôle",
    "SettingsTitle": "Paramètres",
    "ValidationWarning": "Veuillez corriger les erreurs avant de terminer",
    "ServerErrorTitle": "Erreurs de validation",
    "MonthlyBillingWarning": "AVERTISSEMENT : Affecte la facturation mensuelle",
    "UnknownOrDeleted": "[Inconnu ou supprimé]",
    "AddUserLanguage_ButtonHelpLabel": "De l'aide ?",
    "AddUserLanguage_ButtonSubmitLabel": "Sauvez",
    "AddUserLanguage_ButtonCancelLabel": "Annuler",
    "AddUserLanguage_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues lors de la fermeture.",
    "AddUserLanguage_PromptConfirm": "Oui",
    "AddUserLanguage_PromptCancel": "Annuler",
    "AddUserLanguage_DetailsTitle": "Détails de l'utilisateur",
    "NAME": "AddUserLanguage",
    "APIKeys_Title": "Clés API"
}